import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { useCategories } from "../../hooks/categoriesHooks/useCategories";

const NavMenu = ({ menuWhiteClass, sidebarMenu }) => {
  const { data: categories, isLoading } = useCategories();
  const { t, i18n } = useTranslation();

  return (
    <>
      <div
        className={clsx(
          sidebarMenu
            ? "sidebar-menu"
            : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
        )}
      >
        <nav>
          <ul>
            <li className="ps-md-3 ps-lg-4 pe-0">
              <NavLink to={"/"}>{t("home")}</NavLink>
            </li>
            <li className="ps-md-3 ps-lg-4 pe-0">
              <NavLink to={"/shop"}>{t("shop")}</NavLink>
            </li>
            <li className="ps-md-3 ps-lg-4 pe-0">
              <NavLink to={`/category`}>
                {t("categories")}
                {sidebarMenu ? (
                  <span>
                    <i className="fa fa-angle-right"></i>
                  </span>
                ) : (
                  <i className="fa fa-angle-down" />
                )}
              </NavLink>
              <ul className="submenu d-flex flex-column gap-2">
                {categories
                  ?.filter((c) => !c.parent_id)
                  ?.map((category, key) => (
                    <li className="py-0" key={key}>
                      <Link
                        to={`/category/${category.id}`}
                        className="d-flex align-items-center gap-3 nav-category-link"
                      >
                        <img
                          src={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                            category.img
                          }`}
                          alt="category_thumb"
                          loading="lazy"
                          className="object-fit rounded-circle category-thumb"
                          width={"48px"}
                          height={"48px"}
                        />
                        <p style={{ textAlign: "start", marginBottom: 0 }}>
                          {" "}
                          {i18n?.language === "ar"
                            ? category?.name
                            : category?.name_en}
                        </p>
                      </Link>
                    </li>
                  ))}
              </ul>
            </li>
            <li className="ps-md-3 ps-lg-4 pe-0">
              <NavLink to={"/about"}>{t("about")}</NavLink>
            </li>
            <li className="ps-md-3 ps-lg-4 pe-0">
              <NavLink to={"/services"}>{t("our_services")}</NavLink>
            </li>
            <li className="ps-md-3 ps-lg-4 pe-0">
              <NavLink to={"/contact"}>{t("contact")}</NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

NavMenu.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
};

export default NavMenu;
